import React, { FunctionComponent, useMemo, useState } from "react";
import { DataPeriod, GradeLevels } from "../../../../../../store/onboarding/types";
import { Grade } from "../../../../../../store/groups/types";
import EquityBenchmarkFilters from "./EquityBenchmarkFilters";
import EquityBenchmarkTable from "./EquityBenchmarkTable";
import { useEquityBenchmarkData } from "../hooks/useEquityBenchmarkData";

type OwnProps = {
  dataPeriod?: DataPeriod
};

type Props = OwnProps;

const EquityBenchmarksModalContent: FunctionComponent<Props> = (props) => {
  const { dataPeriod } = props;
  const [selectedGradeKey, setSelectedGradeKey] = useState<Grade>("K");
  const [selectedSchool, setSelectedSchool] = useState<number | undefined>();

  // `selectedGradeKey` always has a value (defaults to "K"), so this is
  // effectively "has the user selected a school" - kept as-is to preserve
  // the original behavior of also reacting to grade changes.
  const isPdfExportReady = Boolean(selectedSchool || selectedGradeKey);

  const selectedGrade = useMemo(() => {
    return GradeLevels.find((gl) => gl.value === selectedGradeKey);
  }, [selectedGradeKey]);

  const handleGradeLevelChange = (value: any) => {
    setSelectedGradeKey(value.value);
  };

  const handleSchoolChange = (value: any) => {
    setSelectedSchool(value.value);
  };

  const {
    schoolOptions,
    evidenceColumnGroup,
    raceDictionary,
    specialEducationDictionary,
    ELLDictionary,
    SLDDictionary,
    genderDictionary,
    freeLunchDictionary,
    stats,
    allStudents,
    displayedEvidenceColumns,
  } = useEquityBenchmarkData(selectedGradeKey, selectedSchool);

  // Benchmarks are only shown for system assessments other than "SRSS".
  // Everything else (no assessment selected, non-system assessment, or
  // "SRSS") falls back to the "No equity benchmarks" message.
  const isSupportedAssessment =
    evidenceColumnGroup?.assessment != null &&
    evidenceColumnGroup.assessment.is_system_assessment &&
    evidenceColumnGroup.assessment.name !== "SRSS";
  const hasNoBenchmarks = !isSupportedAssessment;

  return (
    <>
      {evidenceColumnGroup && (
        <h2 className="text-center">{evidenceColumnGroup.assessment != null ? evidenceColumnGroup.assessment.name : ''}</h2>
      )}
      <EquityBenchmarkFilters
        selectedGradeKey={selectedGradeKey}
        selectedSchool={selectedSchool}
        schoolOptions={schoolOptions}
        onGradeLevelChange={handleGradeLevelChange}
        onSchoolChange={handleSchoolChange}
      />

      {hasNoBenchmarks && <h4 className="text-center">No equity benchmarks</h4>}
      {isSupportedAssessment && evidenceColumnGroup && (
        <EquityBenchmarkTable
            dataPeriod={dataPeriod}
            evidenceColumnGroup={evidenceColumnGroup}
            displayedEvidenceColumns={displayedEvidenceColumns}
            selectedGrade={selectedGrade}
            selectedSchool={selectedSchool}
            schoolOptions={schoolOptions}
            allStudents={allStudents}
            raceDictionary={raceDictionary}
            specialEducationDictionary={specialEducationDictionary}
            ELLDictionary={ELLDictionary}
            SLDDictionary={SLDDictionary}
            genderDictionary={genderDictionary}
            freeLunchDictionary={freeLunchDictionary}
            stats={stats}
            isPdfExportReady={isPdfExportReady}
          />
        )}
    </>
  );
};

export default EquityBenchmarksModalContent;

